// Banners do Douto (um componente, vários locais). Mapa completo em docs/douto-banners/MAPA.md.
// PRIVACIDADE: nenhum dado do cálculo, da conta ou do prontuário entra na URL nem nos eventos.
// O único dado enviado é o nome do local do banner (`placement`).
// Texto só com o que está comprovado: apoio à decisão clínica e Primeiro caso grátis + 7 dias de garantia.
// Sem preço, sem número de uso, sem promessa de acurácia.
// NÃO citar canal (WhatsApp etc.): o Douto ainda não funciona por WhatsApp. Só citar quando estiver no ar.
import { DOUTO_HANDOFF_URL } from './doutoHandoff';

export const DOUTO_BANNER_PLACEMENTS = {
  'resultado-lateral': {
    texto: 'E depois do resultado? Tire dúvidas de conduta com o Douto. Primeiro caso grátis + 7 dias de garantia.',
    cta: 'Conhecer o Douto'
  },
  'resultado-rodape': {
    texto: 'E depois do resultado? Tire dúvidas de conduta com o Douto. Primeiro caso grátis + 7 dias de garantia.',
    cta: 'Conhecer o Douto'
  },
  'copiou-prontuario': {
    texto: 'Copiado. Precisa de apoio com a conduta?',
    cta: 'Conheça o Douto'
  },
  'guia-fim': {
    texto: 'Dúvida de conduta depois do escore? Converse com o Douto. Primeiro caso grátis + 7 dias de garantia.',
    cta: 'Conhecer o Douto'
  },
  'calculadora-margem': {
    texto: 'Dúvida de conduta depois do escore? O Douto apoia a decisão clínica. Primeiro caso grátis + 7 dias de garantia.',
    cta: 'Conhecer o Douto'
  },
  menu: {
    texto: '',
    cta: 'Douto'
  },
  'home-faixa': {
    texto: 'Apoio à decisão clínica: leve a dúvida de conduta ao Douto. Primeiro caso grátis + 7 dias de garantia.',
    cta: 'Conhecer o Douto'
  }
};

export const DOUTO_BANNER_AVISO = 'Para profissionais de saúde. Apoio à decisão clínica; não substitui o julgamento do médico.';

export function bannerUrl(placement) {
  const url = new URL(DOUTO_HANDOFF_URL);
  url.search = new URLSearchParams({
    utm_source: 'minimental',
    utm_medium: 'banner',
    utm_campaign: placement
  }).toString();
  return url.toString();
}

/** Eventos genéricos: a única propriedade é o local. */
export function captureBanner(event, placement) {
  window.eidocAnalytics?.capture(event, { placement });
}
